<template>
  <div class="youtube-section">
    <div class="wrap">
      <h2><a class="link-btn" href="https://www.youtube.com/user/Lowco2525" aria-label="external link: youtube channel" title="Youtube.com/user/Lowco2525"</a></h2>
      <transition name="fadeOut" mode="out-in">
        <div v-if="!loading && lowcoGamesVideos !== null && lowcoVideos !== null">
          <h2><a class="link-btn" href="https://www.youtube.com/channel/UC3GZtOeb7Pe2HVYYPk6ilnA" aria-label="external link: Lowco youtube channel" title="Lowco youtube channel">Lowco</a></h2>
          <div class="video-wrapper">
            <youtube-video v-for="lowcoVideo in lowcoVideos" :key="lowcoVideo.id.videoId" :videoId="lowcoVideo.id.videoId"></youtube-video>
          </div>
          <h2><a class="link-btn" href="https://www.youtube.com/user/Lowco2525" aria-label="external link: lowcogames youtube channel" title="Lowco youtube channel">Lowco Games</a></h2>
          <div class="video-wrapper">
            <youtube-video v-for="video in lowcoGamesVideos" :key="video.$index" :videoId="video.contentDetails.videoId"></youtube-video>
          </div>
        </div>
        <loading-spinner class="loading" v-else></loading-spinner>
      </transition>
    </div>
  </div>
</template>

<script>
import YoutubeGateway from '../../gateways/youtube.js'
import LoadingSpinner from '../global/Loading'
import YoutubeVideo from '../global/YoutubeVideo'

export default {
  name: 'youtube-section',
  components: {
    LoadingSpinner,
    YoutubeVideo
  },
  methods: {
    swapPlaylists: function (bool) {
      this.loading = true
      this.showLowcos = bool
      setTimeout(function () { this.loading = false }.bind(this), 1000)
    }
  },
  data () {
    return {
      lowcoGamesVideos: null,
      lowcoVideos: null,
      showLowcos: true,
      loading: true
    }
  },
  created () {
    YoutubeGateway.getPlaylist('PL00vBu4kkMvw7ZjqUx4asSJ-uBI670p08').then(function (results) {
      this.lowcoGamesVideos = results.body.items
      this.loading = false
    }.bind(this))
    YoutubeGateway.getVideos('UC3GZtOeb7Pe2HVYYPk6ilnA').then(function (results) {
      this.lowcoVideos = results.body.items
      this.loading = false
    }.bind(this))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../variables.scss';
.youtube-section {
  padding: $home-section-padding;
  background-color: $dark-purple;
  color: $font-gray;
  text-align: left;
  transition: $standard-transition;
  .loading {text-align: center}
  .wrap {
    max-width: 1200px;
    margin: auto;
  }
  .list-btn {
    svg {
      vertical-align: bottom;
      margin-right: 0.5em;
    }
    h2 {
      display: inline-block;
      margin: 0;
    }
    &.active {
      background-color: $light-purple;
      color: $font-white;
    }
  }
}

.video-wrapper {
  position: relative;
  justify-content: space-between;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
}

@media (max-width: 750px) {
  .youtube-section {
    text-align: center;
  }
  .video-wrapper{
    max-width: 65%;
    margin-left: auto;
    margin-right: auto;
    flex-flow: column;
    align-items: normal;
    margin-top: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// YoutubeSection.vue?7feafe41